module.exports = __webpack_public_path__ + "static/media/icon-location.d0d5642e.svg";